import accountTableTemplate from './reactAccountsTable.html';
import { AccountService } from '../../../services/AccountService';
import { accounts, USER_ACC_REACT } from '../../../services/arsweb/RoutingPaths';
import { reactAccountCols, defaultSortModel } from './accountColDefs';
import { ACCOUNTS_TITLE } from '../../../services/arsweb/TableTitles';
import {ReactEditionTableController} from "../reactEditionTableController";

/** @ngInject */
export function reactEditAccountsTable() {
    return {
        restrict: 'E',
        scope: {
            tableId: '@',
            parentController: '=',
            hideColumns: '='
        },
        templateUrl: accountTableTemplate,
        controller: ReactEditAccountsTableController,
        controllerAs: 'accountsTableController'
    };
}

/** @ngInject */
export class ReactEditAccountsTableController extends ReactEditionTableController {

    constructor($scope, userService, arsMainDependencies ) {

        super($scope, userService, arsMainDependencies, '', new AccountService(userService), accounts,
            ACCOUNTS_TITLE, 'editAccountTableParams', "accountName", false, defaultSortModel);
        this.backendService.service.config.params.filter = {dateTo : this.$rootScope.pickedDate};
        this.ftsMainDependencies.initCompletedPromise.then(() => this.initGrid(userService));
        this.isAllSelected = false;
    }

    initGrid(userService) {
        userService.promise.then(()=> {

            // react account columns
            this.colDefs = reactAccountCols(this.translate, userService,[]);
            this.initCols();

            // edition functionality
            this.defaultReactGridParams.gridOptions.onRowSelected = (row) => {
                if (!this.isAllSelected  && this.isOnScreen(row.api, row.node,'accountName')) {
                    this.updateSelection(row, this.$scope.parentController.element.userAccounts,'accountName')
                } else if(this.isAllSelected) {
                    this.initSelection(row.api);
                }
            };

            this.updateSelectionLength(this.$scope.parentController.element.userAccounts.length);
            const accountGridParams = {
                columnDefs: this.colDefs,
                columnMapping: {'currencyCode' : 'currency', "countryName": "country"},
                url: this.backendService.service.getServiceUrl(USER_ACC_REACT + accounts)};
            delete this.defaultReactGridParams.onReport;
            delete this.defaultReactGridParams.onExport;
            this.reactGridParams = {...this.defaultReactGridParams, ...accountGridParams};
        });
    }

    initSelection(api) {
        if (this.$scope.parentController.element && this.$scope.parentController.element.userAccounts) {
            super.initSelection(api, this.$scope.parentController.element.userAccounts,'accountName');
        }
    }
}
